import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Type assertion for react-router-dom compatibility
const Router = RouterProvider as any;
import { BeatleProvider } from 'beatlejs/integrations/react';
import { Container } from 'beatlejs';
import { ToastProvider } from '@/components/shared/Toast';
import '@/index.css';

import { router } from './router.tsx';

// Create BeatleJS container
const container = Container();

// Initialize dark mode from localStorage
const initializeDarkMode = () => {
  const savedTheme = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  
  if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

// Initialize theme before rendering
initializeDarkMode();

// Listen for system color scheme changes
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
  if (!localStorage.getItem('theme')) {
    if (e.matches) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BeatleProvider container={container}>
    <ToastProvider>
      <Router router={router} />
    </ToastProvider>
  </BeatleProvider>
); 